export const CUSTOMER_STATUSES = ['prospect', 'active', 'inactive', 'archived'];
export const ADDRESS_KINDS = ['billing', 'correspondence', 'visiting'];
/**
 * Normalises a company name for duplicate detection: lowercase, collapsed
 * whitespace, punctuation and common German legal forms removed.
 *
 * Used ONLY to propose a match for human confirmation - never to link records
 * automatically. Identity is always the external id (see work4all-integration.md).
 */
const LEGAL_FORM_PATTERN = /\b(gmbh|mbh|ag|kg|ohg|gbr|ug|e\.?\s?k\.?|se|co|kgaa|ev|gmbh\s?&\s?co)\b/g;
export function buildCustomerMatchKey(name) {
    const normalised = name
        .toLowerCase()
        .replace(/[.,;:()"']/g, ' ')
        .replace(LEGAL_FORM_PATTERN, ' ')
        .replace(/[^a-z0-9äöüß\s-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    if (normalised.length > 0)
        return normalised;
    // A name that is nothing but a legal form ("GmbH") would normalise to the
    // empty string, and every such company would look like a duplicate of every
    // other. Fall back to the plain normalised name instead.
    return name
        .toLowerCase()
        .replace(/[^a-z0-9äöüß\s-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
//# sourceMappingURL=customer.js.map